export default "__VITE_ASSET__DX6B1tPM__"